
export default {

	'екатеринбург': [
		{
			id: 1,
			name: 'Лесопарк имени лесоводов России',
			description: 'Настоящий лес в&nbsp;черте города&nbsp;&mdash; с&nbsp;ягодами, грибами, белками и&nbsp;крапом мелких озер. Подойдет собаке, испытывающей сложности с&nbsp;социализацией (например, недавно взятой из&nbsp;приюта), и&nbsp;хозяину, который ценит одиночество: территория парка велика и&nbsp;пока не&nbsp;слишком освоена отдыхающими. Для последних, впрочем, есть парковка, несколько старых асфальтированных дорожек и&nbsp;cпециальная зона для пикника.',
			address: 'Сибирский тракт, 36а, Екатеринбург, 620100',
			latLng: [56.815559, 60.667596],
		},
		{
			id: 2,
			name: 'Набережная у Театра драмы',
			description: 'Территория вокруг Свердловского театра драмы&nbsp;&mdash; одна из&nbsp;самых благоустроенных в&nbsp;городе: газоны вдоль красивой реки Исеть пострижены, фонтаны чисты и&nbsp;говорливы, а&nbsp;парапеты украшены хорошим стрит-артом. Словом, здесь будут рады спокойным, хорошо воспитанным собакам, привыкшим гулять на&nbsp;поводке: по&nbsp;вечерам у&nbsp;воды собираются любители сальсы и&nbsp;бачаты, а&nbsp;площадку со&nbsp;стороны Макаровского моста занимают скейтеры.',
			address: 'пл. Октябрьская, 2, Екатеринбург, 620077',
			latLng: [56.843925, 60.593138],
		},
		{
			id: 3,
			name: 'Парк имени Павлика Морозова',
			description: 'Парк за&nbsp;зданием Уральского федерального университета разбили еще в&nbsp;1936&nbsp;году. С&nbsp;тех пор он&nbsp;неоднократно приходил в&nbsp;запустение, но&nbsp;был реконструирован в&nbsp;2011 году и&nbsp;сегодня представляет собой отлично организованное общественное пространство с&nbsp;баскетбольной площадкой, скейт-парком и&nbsp;одной из&nbsp;нескольких специальных площадок для выгула собак в&nbsp;городе&nbsp;&mdash; здесь и&nbsp;ровное покрытие с&nbsp;хорошим дренажем, и&nbsp;безопасное ограждение из&nbsp;легкой металлической сетки, и&nbsp;отличная собачья компания в&nbsp;любой день недели.',
			address: 'ул. Павлика Морозова, Екатеринбург, 623702',
			latLng: [56.826536, 60.619767],
		},
		{
			id: 4,
			name: 'Парк «Зеленая роща»',
			description: 'Исторический парк в&nbsp;Ленинском районе извеcтен тем, что на&nbsp;две трети состоит из&nbsp;хвойных деревьев&nbsp;&mdash; сибирских кедров, голубых елей и&nbsp;благородных лиственниц возрастом более полутора веков. Гулять в&nbsp;&laquo;Роще&raquo; приятно всем: есть большой и&nbsp;ухоженный футбольный стадион, турники и&nbsp;спортивные лесенки, современная детская площадка с&nbsp;городком и&nbsp;качелями. А&nbsp;для собак и&nbsp;их&nbsp;хозяев&nbsp;&mdash; множество тропинок и&nbsp;аллей, особенно оживленных в&nbsp;конце недели: воскресенье здесь неофициально считается &laquo;собачьим&raquo; днем.',
			address: 'ул. 8 Марта, 78, Екатеринбург, 620144',
			latLng: [56.820938, 60.595128],
		},
	],

	'новосибирск': [
		{
			id: 5,
			name: 'Михайловская набережная',
			description: 'В&nbsp;прошлом году эффектный променад у&nbsp;Речного вокзала открыли после масштабной реконструкции: поставили яркие фонари, залили широкую велодорожку, проредили старые деревья и&nbsp;высадили новые&nbsp;&mdash; липы и&nbsp;морозоустойчивые яблони. Но&nbsp;главное&nbsp;&mdash; положили вдоль Оби несколько километров качественной, безопасной и&nbsp;амортизирующей плитки, по&nbsp;которой приятно ступать&nbsp;&mdash; и&nbsp;ногам, и&nbsp;лапам.',
			address: 'ул. Большевистская, 33, Новосибирск, 630102',
			latLng: [55.010002, 82.928357],
		},
		{
			id: 6,
			name: 'Центральный парк',
			description: 'Несмотря на&nbsp;то&nbsp;что самый старый парк города, как следует из&nbsp;названия, находится в&nbsp;центре&nbsp;&mdash; между улицами Фрунзе, Мичурина, Каменской и&nbsp;Ядринцевской,&nbsp;&mdash; собаководы сюда приезжают издалека. Дело не&nbsp;только в&nbsp;широких аллеях и&nbsp;аккуратных дорожках, проложенных между осанистыми деревьями, но&nbsp;и&nbsp;в&nbsp;лояльности администрации: животным здесь рады. Хотя и&nbsp;не&nbsp;вполне готовы к&nbsp;четвероногим гостям&nbsp;&mdash; пакетики для уборки придется брать из&nbsp;дома.',
			address: 'ул. Мичурина, 8, Новосибирск, 630091',
			latLng: [55.034413, 82.924288],
		},
		{
			id: 7,
			name: 'Парк культуры и отдыха «У моря Обского»',
			description: 'Практически идеальный городской парк на&nbsp;берегу Новосибирского водохранилища: здоровые и&nbsp;ухоженные деревья, достаточно тени, много дорожек&nbsp;&mdash; как асфальтированных, так и&nbsp;земляных. Есть даже общественный пляж, причем неплохой: можно окунуться самому и&nbsp;искупать собаку, если отойти немного в&nbsp;сторону,&nbsp;&mdash; посетители &laquo;Моря&raquo; исключительно дружелюбны ко&nbsp;всем поклонникам водных процедур.',
			address: 'ул. Софийская, 15, Новосибирск, 630056',
			latLng: [54.844043, 82.957689],
		},
		{
			id: 8,
			name: 'Инюшенский бор',
			description: 'Самый старый и&nbsp;при этом нетронутый хвойный лес Новосибирска&nbsp;&mdash; отличное место для активных прогулок с&nbsp;собакой: ландшафт у&nbsp;бора сложный, с&nbsp;многочисленными склонами и&nbsp;подъемами, холмами и&nbsp;ручьями. Впрочем, есть и&nbsp;умеренно пересеченные участки с&nbsp;аккуратными тропинками для пожилых питомцев. Киосков с&nbsp;напитками в&nbsp;Инюшенском нет, поэтому водой нужно запастись заранее.',
			address: 'ул. Выборная, Новосибирск',
			latLng: [54.995396, 83.002269],
		},
	],

	'москва': [
		{
			id: 9,
			name: '«Сокольники»',
			description: 'По-настоящему дог-френдли-парк: выгул домашних животных здесь более чем приветствуется, и&nbsp;для этого созданы все условия. Есть и&nbsp;специальные зоны для прогулок без поводка, и&nbsp;большая площадка для дрессировки, и&nbsp;клуб собаководов, созданный по&nbsp;инициативе администрации парка. Кроме того, несложно заметить, что в&nbsp;&laquo;Сокольниках&raquo; действительно чисто: на&nbsp;территории парка расположены контейнеры, где можно взять картонный мешочек и&nbsp;совок.',
			address: 'ул. Сокольнический Вал, 1, стр. 1, Москва, 107113',
			latLng: [55.794718, 37.676006],
		},
		{
			id: 10,
			name: 'Парк Горького',
			description: 'За&nbsp;последние годы парк Горького очень изменился: аттракционы уступили место спортивным площадкам и&nbsp;теннисным столам, на&nbsp;широких газонах разместились лежаки, заработал бесплатный Wi-Fi и&nbsp;фонтаны с&nbsp;питьевой водой. А&nbsp;пару лет назад администрация разрешила выгуливать в&nbsp;парке собак, причем на&nbsp;газонах в&nbsp;том числе&nbsp;&mdash; беспрецедентная для Москвы инициатива. Владельцы бизнесов на&nbsp;территории парка ее&nbsp;поддерживают: в&nbsp;киосках продаются мячи, фрисби и&nbsp;все необходимое для активных прогулок с&nbsp;питомцем.',
			address: 'ул. Крымский Вал, 9, Москва, 119049',
			latLng: [55.729212, 37.600804],
		},
		{
			id: 11,
			name: '«Усадьба Трубецких в Хамовниках»',
			description: 'Усадьба Трубецких, она&nbsp;же парк Мандельштама,&nbsp;&mdash; отрада московских Хамовников, привлекающая как владельцев, так и&nbsp;их&nbsp;питомцев: в&nbsp;маленьком парке много зелени, обсаженный плакучими ивами извилистый пруд c&nbsp;утками и&nbsp;специальная площадка для выгула собак. Последняя хорошо оборудована и&nbsp;потому достаточно популярна у&nbsp;местных жителей&nbsp;&mdash; здесь ваш питомец всегда найдет себе компанию.',
			address: 'ул. Усачева, 1, Москва, 119048',
			latLng: [55.728484, 37.577065],
		},
		{
			id: 12,
			name: 'Сходненский ковш',
			description: 'Естественный амфитеатр в&nbsp;природном парке &laquo;Тушинский&raquo;, образованный петлей реки Сходни, одинаково хорошо известен киноманам и&nbsp;местным собаководам. Первые знают Сходненскую чашу благодаря &laquo;Нелюбви&raquo; Звягинцева, которая частично снималась здесь, вторые&nbsp;&mdash; потому что в&nbsp;ковше замечательно гулять с&nbsp;собаками. Судите сами: прекрасный смешанный лес, сохранивший свой первоначальный вид, цветущие луга и&nbsp;поляны с&nbsp;облепихой. Местность вдоль реки более обжитая, чем другие территории ковша: днем здесь собираются рыбаки.',
			address: 'проезд Донелайтиса, Москва, 125476',
			latLng: [55.844840, 37.411162],
		},
		{
			id: 13,
			name: 'Воронцовский парк',
			description: 'Владельцы собак очень уважают этот красивый усадебный парк на&nbsp;юге Москвы, ведь здесь есть все, что нужно для долгих и&nbsp;правильно организованных прогулок. Плавные подъемы и&nbsp;спуски&nbsp;&mdash; да. Хорошо освещенные места и&nbsp;спасительная тень&nbsp;&mdash; галочка. Стриженые газоны и&nbsp;участки с&nbsp;высокой травой&nbsp;&mdash; да! Словом, гулять здесь можно часами, главное&nbsp;&mdash; не&nbsp;забывать про поводок и&nbsp;намордник: летом в&nbsp;Воронцовском много велосипедистов и&nbsp;любителей верховой езды.',
			address: 'тер. Воронцовский парк, 3, Москва, 117393',
			latLng: [55.667054, 37.531910],
		},
	],

	'Санкт-Петербург': [
		{
			id: 14,
			name: 'Новосмоленская набережная',
			description: 'Длинный променад в Василеостровском районе отлично подходит для долгих прогулок с собаками: во-первых, дорожки с лужайками ограждены от дороги и находятся чуть ниже ее, во-вторых — достаточно места, чтобы прохожие не путались в поводках, а в-третьих — у воды прохладно и свежо даже летом. Кроме того, с набережной открывается эффектный вид на берег Смоленки со знаменитыми домами на «курьих ножках» у метро «Приморская».',
			address: 'Новосмоленская наб., 1к4, Санкт-Петербург, 199397',
			latLng: [59.949516, 30.224418],
		},
		{
			id: 15,
			name: 'Парк «Куракина дача»',
			description: 'До восстановительных работ «Куракина дача» напоминала болото, а сейчас в парке приятно находиться и мамам с детьми, и спортсменам, и собаководам: в процессе реконструкции восстановили старинный пруд и высадили более 10 тысяч кустарников. Дренажную и ливневую систему, из-за которой газоны «Дачи» летом превращались в болото, привели в порядок, и теперь здесь можно гулять все лето напролет.',
			address: 'Санкт-Петербург, 192174',
			latLng: [59.872907, 30.450333],
		},
		{
			id: 16,
			name: 'Опочининский сад',
			description: 'Один из самых элегантных садов Васильевского острова — небольшой, площадью около трех гектаров, но красиво спланированный: c длинной живой изгородью из роз, рощицами душистой венгерской сирени и сетью дорожек из гравия и дробленого сланца. Большим собакам такой состав подойдет, а вот маленькие могут предпочесть более однородное и плотное покрытие.',
			address: 'б-р Красных Зорь, Санкт-Петербург, 192131',
			latLng: [59.872922, 30.450355],
		},
		{
			id: 17,
			name: 'Шуваловский парк',
			description: 'Холмистый рельеф, мягкая и пружинистая подстилка из иголок вековых елей, дюжина прохладных прудов — все это про Шуваловский парк на севере города. Пробы воздуха показывают, что гулять здесь в прямом смысле слова полезно: в воздухе содержится большое количество летучих фитонцидов — выделяемых хвойными деревьями веществ, которые нормализуют давление и иммунитет (в том числе у собак). К сожалению, проникнуть на территорию старого имения Шуваловых не получится — она огорожена, но в парке и без того великое множество зеленых аллей.',
			address: 'Выборгский район, Санкт-Петербург, 194362',
			latLng: [60.075921, 30.305207],
		},
	],
}



// WEBPACK FOOTER //
// ./src/data/places.js